﻿export interface IReferral {
    id: number,
    editKey: string,
    referralEntityTypeId: string,
    referralEntityType: string,
    entityTypeId: number,
    gender: string,
    bloodType: string,
    birthDate: string,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    address: string,
    city: string,
    stateId: number,
    state: string,
    postalCode: string,
    referralStepId: number,
    referralStep: string,
    isRecipient: boolean,
    isInterestedInAdp: boolean,
    agreedToHipaaRelease: boolean,
    hasDonor: boolean,
    hasCompatibleDonor: boolean,
    numberOfDonors: number,
    donorSituation: string,
    createdDateTime: string,
    followUpsSent: number,
    isLeadRetrieved: boolean,
    remindersSent: number,
    dispositionRemindersSent: number,
    hasAdminFollowedUp: boolean,
    leadFormUsed: string,
    leadSource: string,
    leadDisposition: string,
    leadDispositionDate: string,
    completedDateTime: string,
    micrositeSituation: number,
    micrositeHipaaRelease: boolean,
    isOnDeceasedDonorList: number,
    isWillingToTransfer: number,
    name: string,
    urgencyId: number,
    urgency: string,
    referralDonorSituationId: number,
    referralDonorSituation: string,
    referralPatientSituationId: number,
    referralPatientSituation: string,
    previousStepId: number,
    previousStep: string,
    hasMicrosite: boolean,
    isKidneyForLifeParticipant: boolean,
    isKidneyForLife: boolean
}
